export default __webpack_public_path__ + "static/media/actionCommunity.31e27504.svg";